var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trip-monthly-distribution-wrap"},[_c('chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}}),_c('div',{staticClass:"custom-tooltip-label",staticStyle:{"opacity":"0"},attrs:{"id":"custom-tooltip"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }